import { ApiError } from "@/lib/api"
import type { TranslationKey, TranslationVariables } from "@/lib/translations"

/** The active language's translator, passed in because this module has no hooks */
type Translate = (key: TranslationKey, variables?: TranslationVariables) => string

/** The service's to-many layout validation codes (AtsPullErrorCodes) and the wording shown for each */
const PULL_ERROR_CODES = new Map<string, TranslationKey>([
  ["ToManyOptionDuplicate", "pull.errors.toManyOptionDuplicate"],
  ["ToManyRowsLimit", "pull.errors.toManyRowsLimit"],
  ["ToManyFieldSpelledTwice", "pull.errors.toManyFieldSpelledTwice"],
  ["ToManyOptionNeedsEntityPrefix", "pull.errors.toManyOptionNeedsEntityPrefix"],
  ["ToManyOptionNotSelected", "pull.errors.toManyOptionNotSelected"],
  ["ToManyNestedNotInCsv", "pull.errors.toManyNestedNotInCsv"],
  ["ToManyRowsNeedsItemPath", "pull.errors.toManyRowsNeedsItemPath"],
])

/**
 * The message to show for a failed pull call: a known service code in the user's
 * language, else the service's own problem detail, else the error's message, else the
 * fallback. Only a problem detail is shown, since the body of an unhandled failure
 * carries the raw exception text.
 */
export function pullErrorMessage(err: unknown, fallback: string, t: Translate): string {
  const detail = err instanceof ApiError && typeof err.errorData?.detail === "string" ? err.errorData.detail : null
  const key = detail === null ? undefined : PULL_ERROR_CODES.get(detail)
  if (key) return t(key)
  return detail ?? (err instanceof Error ? err.message : fallback)
}
